import axios from "./axios";

export const listUsersInTenant = async (tenantName) => {
  return await axios.get(`/api/v1/um/tenants/${tenantName}/users`);
};

export const getUserInTenant = async (tenantName, userName) => {
  return await axios.get(`/api/v1/um/tenants/${tenantName}/users/${userName}`);
};

export const createUsersInTenant = async (tenantName, data) => {
  const { name, ...rest } = data;
  return await axios.post(`/api/v1/um/tenants/${tenantName}/users/${name}`, rest, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

export const updateUsersInTenant = async (tenantName, userName, data) => {
  return await axios.put(`/api/v1/um/tenants/${tenantName}/users/${userName}`, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

export const deleteUsersInTenant = async (tenantName, userName) => {
  return await axios.delete(`/api/v1/um/tenants/${tenantName}/users/${userName}`);
}

export const syncCreationToVIA = async (tenantName, userName) => {
  return await axios.post(`/api/v1/provision/util?op=create.user.in.tenant&tenant=${tenantName}&user=${userName}`);
}

export const syncDeletionToVIA = async (tenantName, userName) => {
  return await axios.post(`/api/v1/provision/util?op=delete.user.in.tenant&tenant=${tenantName}&user=${userName}`);
}

export const syncUpdateToVIA = async (tenantName, userName) => {
  return await axios.post(`/api/v1/provision/util?op=update.user.in.tenant&tenant=${tenantName}&user=${userName}`);
}